import { render, staticRenderFns } from "./maintain-fba-shipment-modal.vue?vue&type=template&id=376d1b34&scoped=true&"
import script from "./maintain-fba-shipment-modal.vue?vue&type=script&lang=js&"
export * from "./maintain-fba-shipment-modal.vue?vue&type=script&lang=js&"
import style0 from "./maintain-fba-shipment-modal.vue?vue&type=style&index=0&id=376d1b34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376d1b34",
  null
  
)

export default component.exports